module.exports = __webpack_public_path__ + "static/img/07patient.301b4e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/07patient.png
// module id = KEtX
// module chunks = 1